require('./bootstrap');

require('date-input-polyfill')

import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()